export default "__VITE_ASSET__BYdTGlqT__"